'use client';

import type { ReactNode } from 'react';
import { SettingsRow, SettingsEmptyState } from '@terra/ui-design-system';
import { Delete01Icon } from '@terra/ui-icons';

export type ProxySettingsListItem = {
  key: string;
  label: string;
  value?: string;
};

export const renderProxySettingsListRows = ({
  items,
  emptyText,
  removeLabel,
  onRemove,
}: {
  items: ReadonlyArray<ProxySettingsListItem>;
  emptyText: string;
  removeLabel: string;
  onRemove: (key: string) => void;
}): ReactNode[] =>
  items.length === 0
    ? [<SettingsEmptyState key="empty">{emptyText}</SettingsEmptyState>]
    : items.map((item) => (
        <SettingsRow
          key={item.key}
          label={item.label}
          value={item.value}
          action={{
            label: removeLabel,
            icon: <Delete01Icon size={16} />,
            onClick: () => onRemove(item.key),
          }}
        />
      ));
